export const SET_AUTH_URLS = "SET_AUTH_URLS";
export const SET_USER_ROLES = "SET_USER_ROLES";
